import PropTypes from 'prop-types';

import NotificationStatusIcon from 'Notifications/NotificationStatusIcon';

import './styles/panelStyles.css';

const typesCSS = {
  danger: 'border-l-red-3',
  info: 'border-l-blue-3',
  success: 'border-l-green-3',
  warning: 'border-l-orange-3',
  working: 'border-l-gray-5',
};
const ContextPanel = ({ children, className, iconAlt, type, ...rest }) => {
  return (
    <div
      className={`context-panel-styles p-4 border-l-4 ${typesCSS[type]} ${className}`}
      {...rest}
    >
      <span className="flex flex-row">
        <NotificationStatusIcon alt={iconAlt} type={type} />
        <span>{children}</span>
      </span>
    </div>
  );
};

ContextPanel.defaultProps = {
  className: '',
  iconAlt: '',
};

ContextPanel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  iconAlt: PropTypes.string,
  type: PropTypes.oneOf(['danger', 'info', 'success', 'warning', 'working'])
    .isRequired,
};

export default ContextPanel;
